<template>
  <div
    class="mete-cols__wrap"
    v-loading="loading"
    element-loading-text="加载中"
  >
    <div class="mete-cols__button">
      <el-button
        v-if="!loading && translateX !== 0 && data.length"
        icon="el-icon-d-arrow-left"
        circle
        @click="moveLeftEnd"
      ></el-button>
      <el-button
        icon="el-icon-arrow-left"
        circle
        :disabled="translateX === 0"
        @click="moveLeft"
      ></el-button>
    </div>

    <div class="mete-cols__container">
      <div v-if="!loading && !data.length" class="mete-cols__content no-data">
        <span>暂无数据</span>
      </div>
      <div
        v-else
        class="mete-cols__content"
        :style="{ transform }"
        :class="{ drag: moving }"
      >
        <div class="mete-cols__border" v-for="p in data" :key="p.id">
          <div class="mete-cols__img">
            <svg-icon :icon-class="p.icon" :color="p.color"></svg-icon>
            <div class="mete-cols__value">{{ `${p.value} ${p.unit}` }}</div>
            <span class="mete-cols__name">{{ p.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mete-cols__button">
      <el-button
        icon="el-icon-arrow-right"
        circle
        :disabled="(!loading && translateX === min) || min >= 0"
        @click="moveRight"
      ></el-button>

      <el-button
        v-if="!loading && data.length && translateX !== min && min < 0"
        icon="el-icon-d-arrow-right"
        circle
        @click="moveRightEnd"
      ></el-button>
    </div>
  </div>
</template>

<script>
const MOVE_LENGTH = 500 // 每次点击移动的距离
// const DURATION = 1 // 动画持续时间 (s)

export default {
  props: {
    loading: Boolean,
    data: Array
  },
  data() {
    return {
      translateX: 0,
      offset: 0,
      moving: false,
      min: 0,
      loadLimit: 10
    }
  },
  computed: {
    transform() {
      return `translate(${this.translateX}px, 0)`
    }
  },
  mounted() {
    document.addEventListener('mouseup', this.onMouseup)
    const container = document.getElementsByClassName('mete-cols__container')[0]
    const el = document.getElementsByClassName('mete-cols__content')[0]
    this.min = container.offsetWidth - el.offsetWidth
  },
  methods: {
    moveStart(e) {
      if (e.button !== 0) return

      e.preventDefault()
      this.moving = true
      this.offset = this.translateX - e.clientX
    },
    move({ clientX: x }) {
      if (this.moving) {
        const offset = x + this.offset

        if (offset > 0) {
          this.translateX = 0
        } else if (offset < this.min) {
          this.translateX = this.min
        } else {
          this.translateX = offset
        }
      }
    },
    onClick(id) {
      this.$emit('change', id)
    },
    onMouseup() {
      this.moving = false
      this.offset = 0
    },
    moveLeft() {
      const offset = this.translateX + MOVE_LENGTH
      if (offset > 0) {
        this.translateX = 0
      } else {
        this.translateX = offset
      }
    },
    moveRight() {
      const offset = this.translateX - MOVE_LENGTH
      const limit = this.loadLimit + 7
      this.loadLimit = limit > this.data.length ? this.data.length : limit
      if (offset < this.min) {
        this.translateX = this.min
      } else {
        this.translateX = offset
      }
    },
    moveLeftEnd() {
      this.translateX = 0
    },
    moveRightEnd() {
      this.loadLimit = this.data.length
      this.translateX = this.min
    }
  },
  watch: {
    data() {
      this.$nextTick(() => {
        const container = document.getElementsByClassName(
          'mete-cols__container'
        )[0]
        const el = document.getElementsByClassName('mete-cols__content')[0]
        this.min = container.offsetWidth - el.offsetWidth
        this.translateX = 0
      })
    }
  }
}
</script>

<style lang="scss">
.mete-cols__wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // max-width: 1270px;
  background-color: #e4e7ed;
  z-index: 2;
  height: 150px;
  border-bottom: 1px solid #dcdfe6;
  .mete-cols__container {
    overflow: hidden;
  }
  .mete-cols__button {
    width: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
  }
  .mete-cols__content {
    float: left;
    left: 10%;
    height: 100%;
    white-space: nowrap;
    transition: transform 0.5s;
  }
  .mete-cols__border {
    position: relative;
    display: inline-block;
    // height: 150px;
    padding-top: 16px;
    padding-bottom: 16px;
    &:not(:last-child) {
      margin-right: 2rem;
    }
  }
  .mete-cols__img {
    width: 118px;
    height: 118px;
    background: #fff;
    border-radius: 50%;
    // border: solid 2px rgba(0, 0, 0, 0.7);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    user-select: none;
    .svg-icon {
      width: 30px;
      height: 30px;
      margin-bottom: 4px;
    }
    .mete-cols__value {
      font-size: 15px;
      color: #606266;
      margin-bottom: 4px;
    }
    .mete-cols__name {
      font-size: 12px;
      color: #606266;
    }
  }
  .el-image.is-actived {
    border: 2px solid red;
  }
  .empty {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .drag {
    transition: none;
  }
}
</style>
